import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const AddSellerBroker = createAsyncThunk(
  "Docs/AddSellerBroker",
  async ({ id, schema, handleSuccess, handleError }, thunkAPI) => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}api/docs/folders/${id}/sellers-brokers`;

      const { data } = await axios.post(url, schema, {
        headers: { "Content-Type": "application/json" },
      });

      handleSuccess?.();
      return data;
    } catch (error) {
      const message =
        error.response?.data?.errorMessage ||
        error.response?.data?.message ||
        error.message;

      handleError?.(message);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
